export const SITE_DOMAIN = 'breathlab.studio';
export const SITE_BASE_URL = `https://${SITE_DOMAIN}`;
export const BREATHWORK_COUNT = 18;

/** Facebook App ID — used by the fb:app_id Open Graph meta tag. */
export const FACEBOOK_APP_ID = '635851059357796';
